/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useDeviceMediaQuery } from '../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'

const PositionNumber = ({position}) => {
    const {isMobile} = useDeviceMediaQuery()

    return (
      <div
        css={css`
            position: absolute;
            top: ${isMobile ? '-.5rem' : '.2rem'};
            left: ${isMobile ? '-.5rem' : '.2rem'};
            padding: 0.25rem 0.5rem;
            background-color: #00b5ad;
            border-radius: 5px;
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            z-index: 9999;
            pointer-events: none;
            color: white;
            //box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            border: 1px solid grey;
        `}
      >
          {position}
      </div>
    )
}
export { PositionNumber }
